export const _localStyle = () => {
    if (!window.location.href.includes("vipdev")) return; // for local only

    let _style = document.querySelector(".vipdev-style");
    if (!_style) {
        _style = document.createElement("style");

        document.head.appendChild(_style);

        _style.innerHTML =
            `:root {` +
            `--wp--style--global--content-size: 100%` +
            `}` +
            `html, body { margin: 0 !important; }` +
            `#wpadminbar, #a8c-debug-flag, #vip-non-prod-bar { display: none !important; }`;
    }
};
